import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e72e4240"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_use_stock_out",
  ref: "useStockOut",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1200px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_import_declaration_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { class: "fs-6 text-gray-400 text-uppercase" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }
const _hoisted_13 = { class: "modal-footer flex-right" }
const _hoisted_14 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_15 = {
  key: 0,
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_18 = { class: "indicator-progress" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.edit")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_table, {
                  class: "mb-7 w-100",
                  ref: "multipleTableRef",
                  data: _ctx.formData.items
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('salesOrder.orderNumber'),
                      prop: "sale_order_number",
                      width: "140"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("div", null, _toDisplayString(row.sale_order_number), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(row.order_item_position), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('fulfillmentOrder.fulfillmentOrderNumber'),
                      prop: "fulfillment_order_number",
                      width: "100"
                    }, null, 8, ["label"]),
                    (_ctx.typeSameRule)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: _ctx.t('order.price'),
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.t("order.sellingPrice")) + ": " + _toDisplayString(_ctx.$currency.currency(
                          row.base_unit_sales_order_price,
                          2,
                          ".",
                          "",
                          ""
                        )), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.shipment_type == '2')
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          label: _ctx.t('order.unpForExportDeclaration')
                        }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              class: "mb-0",
                              rules: _ctx.rules['items.unp_for_export_declaration'],
                              prop: 'items.' + $index + '.unp_for_export_declaration'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  class: "w-100 text-center",
                                  modelValue: row.unp_for_export_declaration,
                                  "onUpdate:modelValue": ($event: any) => ((row.unp_for_export_declaration) = $event),
                                  precision: 2,
                                  step: 0.01,
                                  disabled: _ctx.props.status != '10' || _ctx.props.invoice_status != 10
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["rules", "prop"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.shipment_type == '2')
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          label: _ctx.t('order.unpForImportDeclaration')
                        }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              class: "mb-0",
                              rules: _ctx.rules['items.unp_for_import_declaration'],
                              prop: 'items.' + $index + '.unp_for_import_declaration'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  class: "w-100 text-center",
                                  modelValue: row.unp_for_import_declaration,
                                  "onUpdate:modelValue": ($event: any) => ((row.unp_for_import_declaration) = $event),
                                  precision: 2,
                                  step: 0.01,
                                  disabled: _ctx.props.status != '10' || _ctx.props.invoice_status != 10
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["rules", "prop"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.quantity'),
                      width: "180"
                    }, {
                      default: _withCtx(({ row, $index }) => [
                        _createVNode(_component_el_form_item, {
                          class: "mb-0",
                          rules: _ctx.rules['items.quantity'],
                          prop: 'items.' + $index + '.quantity'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input_number, {
                              class: "w-100 text-center",
                              modelValue: row.quantity,
                              "onUpdate:modelValue": ($event: any) => ((row.quantity) = $event),
                              precision: 0,
                              step: 1,
                              min: 1,
                              max: row.max_quantity,
                              disabled: 
                          _ctx.props.status != '10' || _ctx.props.invoice_status != 10 || _ctx.props.shipment_type != '2'
                        
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "disabled"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "prop"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('common.creationDate')
                    }, {
                      default: _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.created_at)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    (_ctx.props.status == '10' && _ctx.typeSameRule && _ctx.props.invoice_status == 10)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 3,
                          label: _ctx.t('common.action')
                        }, {
                          default: _withCtx(({ row, index }) => [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "btn btn-sm btn-icon btn-light-danger",
                              onClick: ($event: any) => (_ctx.removeItem(row, index))
                            }, [
                              _createElementVNode("span", _hoisted_12, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ])
                            ], 8, _hoisted_11)), [
                              [_directive_auth, { auth: ['update'] }]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data"])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_13, [
              (0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "reset",
                    class: "btn btn-light me-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                default: _withCtx(() => [
                  (_ctx.props.status == '10' && _ctx.typeSameRule && _ctx.props.invoice_status == 10)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                        ]),
                        _createElementVNode("span", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                          _hoisted_19
                        ])
                      ], 512))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}